import {
  useAdvert as useGoogleAdvert,
  useAdverts as useGoogleAdverts,
} from "../../../client/googleAdverts";
import { useSelector } from "react-redux";
import {
  getAppLevelTargeting,
  getAdSpecificTargeting,
  getValidSlotSizes,
  getPriorProductsFingerprint,
  getAdUnitPath,
  getPageLevelTargeting,
} from "../../../state/modules/adverts";
import config from "../../../config/common";
import getHashedCustomerIdPromise from "./getHashedCustomerIdPromise";

const useAdvert = () => {
  const {
    adverts: {
      adId: id,
      scriptSrc,
      sizeMappings,
      fetchMarginPercent,
      renderMarginPercent,
      mobileMarginScaling,
    },
  } = config;

  const adUnitPath = useSelector(getAdUnitPath);
  const appLevelTargeting = useSelector(getAppLevelTargeting);
  const pageLevelTargeting = useSelector(getPageLevelTargeting);
  const validSlotSizes = useSelector(getValidSlotSizes);
  const priorProductsFingerprint = useSelector(getPriorProductsFingerprint);
  const advertSpecificTargeting = useSelector(getAdSpecificTargeting);

  if (!adUnitPath) {
    return null;
  }

  if (CLIENT) {
    const hashedCustomerIdPromise = getHashedCustomerIdPromise();
    const targeting = { ...appLevelTargeting, ...pageLevelTargeting };
    // eslint-disable-next-line react-hooks/rules-of-hooks -- CLIENT is a compile-time constant (webpack DefinePlugin)
    useGoogleAdverts({
      scriptSrc,
      fetchMarginPercent,
      renderMarginPercent,
      mobileMarginScaling,
      targeting,
      hashedCustomerIdPromise,
    });

    // eslint-disable-next-line react-hooks/rules-of-hooks -- CLIENT is a compile-time constant (webpack DefinePlugin)
    useGoogleAdvert({
      id,
      sizeMappings,
      adUnitPath,
      targeting: advertSpecificTargeting,
      validSlotSizes,
      priorSiblingsFingerprint: priorProductsFingerprint,
    });
  }

  return id;
};

export default useAdvert;
